export const PATHS = {
  // Public paths
  SIGN_IN: '/signin',
  OAUTH2_REDIRECT: '/oauth2/redirect',
  OAUTH2_SIGNOUT: '/oauth2/signout',

  // Protected paths
  ACCESS_DENIED: '/access-denied',
  ANALYSIS: '/tenants/:tenantShortName/analysis/:assetId',
  ASSETS: '/tenants/:tenantShortName/assets/:folderId?',
  ASSET: '/tenants/:tenantShortName/asset/:assetId',
  CHANGELOG: '/changelog',
  COMPARE: '/tenants/:tenantShortName/compare',
  REPORT: '/tenants/:tenantShortName/report',
  REPORT_DETAIL: '/tenants/:tenantShortName/report/:id/:groupId?',
  METADATA: '/tenants/:tenantShortName/metadata',
  METADATA_BULK_UPLOAD: '/tenants/:tenantShortName/metadata-upload',
  PART_FINDER: '/tenants/:tenantShortName/part-finder',
  PART_FINDER_REPORT: '/tenants/:tenantShortName/part-finder-reports/:id',
  SEARCH: '/tenants/:tenantShortName/search',
  SUITABLE_SUBSTITUTES: '/tenants/:tenantShortName/suitable-substitutes',
  STATUS: '/tenants/:tenantShortName/status',
  TENANTS: '/tenants',
  USERS: '/tenants/:tenantShortName/users',
} as const;
